import { styled } from '@linaria/react';

export interface MarketHeaderWrapperProps {
  numberOfCells: number;
}

export const MarketHeaderWrapper = styled.div<MarketHeaderWrapperProps>`
  --oc-max-grid-width: calc((${props => props.numberOfCells} * (var(--ogm-grid-column-width) + 3px) + 4px + 220px));
  display: flex;
  align-items: center;
  width: 100%;
  height: 46px;
  overflow: hidden;

  @media (min-width: 1256px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      margin: 0 auto;
      border-bottom: 1px solid var(--oc-line-secondary);
    }
  }

  @media (min-width: 1360px) {
    padding: 0;
  }
`;

export const Header = styled.h4`
  display: flex;
  align-items: center;
  flex: 0 0 220px;
  white-space: wrap-word;
  margin-right: 10px;

  font-family: var(--ogm-font-family-1);
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 22px;
`;
